<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button  :loading="executeLoading" :disabled="executeLoading"  type="primary" class="btn primary" @click="manualExecution(1)">手动执行</el-button>
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
          v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.rfid" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" :span-method="objectSpanMethod" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>
        <!-- <el-table-column type="index" width="50"> </el-table-column> -->
        <el-table-column prop="rfid" width="170" label="RFID码" show-overflow-tooltip></el-table-column>
        <el-table-column show-overflow-tooltip prop="cabinetName" width="120" label="智能柜"></el-table-column>
        <el-table-column show-overflow-tooltip prop="typeName" width="80" label="出入类型"></el-table-column>
        <el-table-column prop="createdTime" label="操作时间" width="165">
          <template slot-scope="scope">
            {{ scope.row.createdTime ? parseTime(new Date(scope.row.createdTime)): ""}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createdUserName" width="100" label="操作人"></el-table-column>
        <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
        <el-table-column show-overflow-tooltip prop="productName" width="160" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="specName" width="120" label="规格型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="stateName" width="80" label="状态"></el-table-column>
        <el-table-column show-overflow-tooltip prop="failureNumber" width="80" label="失败次数"></el-table-column>
        <el-table-column show-overflow-tooltip prop="reason" width="120" label="原因">
          <template slot-scope="scope">
            {{scope.row.reason?scope.row.reason:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="validityDate" label="有效期" width="110">
          <template slot-scope="scope">
            {{scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}"): "-"}}
          </template>
        </el-table-column>
        <el-table-column prop="longTime" label="长期" width="60">
          <template slot-scope="scope">
            {{ scope.row.longTime == 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="batch" label="批次号" width="120" />
        <el-table-column prop="serialNo" label="序列号" width="120">
          <template slot-scope="scope">
            {{scope.row.serialNo?scope.row.serialNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="number" width="60" label="数量">
          <template slot-scope="scope">
            {{scope.row.number?scope.row.number:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="unit" width="80" label="包装单位">
          <template slot-scope="scope">
            {{scope.row.unit?scope.row.unit:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="minUnit" width="80" label="最小单位"></el-table-column>
        <el-table-column prop="price" width="80" label="单价"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="165">
          <template slot-scope="scope">
            {{
              scope.row.createdTime
                ? parseTime(new Date(scope.row.createdTime))
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="traceId" width="160" label="TraceId"></el-table-column>
        <el-table-column show-overflow-tooltip prop="mainNo" width="160" label="主条码">
          <template slot-scope="scope">
            {{scope.row.mainNo?scope.row.mainNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="traceNo" width="160" label="溯源码">
          <template slot-scope="scope">
            {{scope.row.traceNo?scope.row.traceNo:'-'}}
          </template>
        </el-table-column>
        <!-- <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button v-if="scope.row.state==2" type="text" v-preventReClick @click="manualExecution(2,scope.row)" class="color-blue" >手动执行</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import {
  GetCabinetRfidChanges,
  ExportCabinetRfidChanges,
  RfidChangeByIds
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { InOutStockTypeOptions,RFIDChangeStateOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      exportAction: ExportCabinetRfidChanges,
      GetDatasAction: GetCabinetRfidChanges,
      InOutStockTypeOptions: InOutStockTypeOptions,
      RFIDChangeStateOptions: RFIDChangeStateOptions,
      filterOptions: [
        {
          name: "RFID码",
          type: "input",
          code: "rfid",
        },
        {
          name: "traceId",
          type: "input",
          code: "traceId",
        },
        {
          name: "出入类型",
          type: "select",
          code: "type",
          data: InOutStockTypeOptions,
        },
        {
          name: "状态",
          type: "select",
          code: "state",
          data: RFIDChangeStateOptions,
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "智能柜",
          type: "select",
          code: "intelligenceCounterId",
          filterMethod: this.getIntelligenceCounters,
          data: [],
        },
        {
          name: "操作时间",
          type: "datetimerange",
          code: "date",
          format:'yyyy-MM-dd HH:mm:ss',
        },
        {
          name: "操作人",
          type: "select",
          code: "userId",
          filterMethod: this.getCabinetRfidChangeUserInfo,
          data: [],
        },
    
      ],
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      details: [],
      open: false,
      spanArr: [],
      executeLoading: false,
    };
  },
  computed: {
    system_setting () {
      return this.$store.getters.system_setting;
    },
  },
  mounted () {
    this.getData();
  },
  methods: {
    // 获取列表
    getData () {
       if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.GetDatasAction(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;

          this.getSpanArr(this.tableData);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
     
      this.$set(this.query, "pageIndex", 1);
     
      this.loading = true;
      this.getData();
    },

    getSpanArr (data) {
      this.spanArr = [];
      if (!data) {
        return;
      }
      // data就是我们从后台拿到的数据
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].rfid === data[i - 1].rfid && data[i].type === data[i - 1].type) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        // console.log(this.spanArr);
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log(column)
      if (column.property == "rfid") {
        // || column.property == "printingTimes"
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        // console.log(`rowspan:${_row} colspan:${_col}`);
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    manualExecution(num,row){
      
    
      let ids = []
      if(num==1){
        if(this.multipleSelection.length==0){
        this.$message({
          message: '请勾选数据',
          type: 'warning'
        });
        return
      }
      
      // 检查是否存在相同rfid且相同type的数据
      const rfidTypeMap = new Map();
      let hasDuplicate = false;
      let duplicateRfid = '';
      let duplicateType = '';
      
      for (const item of this.multipleSelection) {
        const key = `${item.rfid}_${item.type}`;
        if (rfidTypeMap.has(key)) {
          hasDuplicate = true;
          duplicateRfid = item.rfid;
          duplicateType = item.typeName;
          break;
        }
        rfidTypeMap.set(key, true);
      }
      
      if (hasDuplicate) {
        this.$message({
          message: `存在相同RFID(${duplicateRfid})且相同类型(${duplicateType})的数据，请重新选择`,
          type: 'warning'
        });
        return;
      }
      
      if(this.multipleSelection.some(e=>e.state==1)){
        this.$message({
          message: '只能勾选失败数据',
          type: 'warning'
        });
        return
      }
        this.executeLoading = true
        ids = this.ids
      }else{
        ids = [row.id]
      }
      RfidChangeByIds({ids}).then(res=>{
        if(res.successful){
          this.$message({
            message: '执行成功',
            type: 'success'
          });
          this.getData()
          if(num == 1){
            this.$refs.multipleTable.clearSelection();
          }
        }
        setTimeout(()=>{
           this.executeLoading = false
        },2000)
      })
     
    }
  },
};
</script>

<style lang="scss" scoped></style>
